var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.makePostRequest}},[_vm._v("Make POST Request")]),_c('button',{on:{"click":_vm.makeGetRequest}},[_vm._v("Make GET Request")]),(_vm.getResponse)?_c('div',[_c('h3',[_vm._v("GET Response:")]),_c('pre',[_vm._v(_vm._s(_vm.getResponse))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }